"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function () {}; return { s: F, n: function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (e) { throw e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function () { it = it.call(o); }, n: function () { var step = it.next(); normalCompletion = step.done; return step; }, e: function (e) { didErr = true; err = e; }, f: function () { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        let key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: () => from[key],
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
// If the importer is in node compatibility mode or this is not an ESM
// file that has been converted to a CommonJS file using a Babel-
// compatible transform (i.e. "__esModule" has not been set), then set
// "default" to the CommonJS "module.exports" for node compatibility.
isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: true
}) : target, mod));
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);
var client_exports = {};
__export(client_exports, {
  RealtimeSession: () => RealtimeSession
});
module.exports = __toCommonJS(client_exports);
var import_events = __toESM(require("events"));
var import_connection = require("../config/connection");
var import_handlers = require("./handlers");
var import_types = require("../types");
var nodeWrapper = __toESM(require("../realtime/node"));
var webWrapper = __toESM(require("../realtime/browser"));
var chromeWrapper = __toESM(require("../realtime/extension"));
class RealtimeSession {
  constructor(config) {
    this.emitter = new import_events.default();
    this.connectionConfig = new import_connection.ConnectionConfigFull(config);
    let socketImplementation = null;
    if (typeof window !== "undefined") {
      socketImplementation = new webWrapper.WebSocketWrapper();
    } else if (typeof chrome !== "undefined") {
      socketImplementation = new chromeWrapper.WebSocketWrapper();
    } else if (typeof process !== "undefined") {
      socketImplementation = new nodeWrapper.NodeWebSocketWrapper();
    } else {
      throw new Error("Unsupported environment");
    }
    this.rtSocketHandler = new import_handlers.RealtimeSocketHandler(this.bindHandlers(), socketImplementation);
  }
  bindHandlers() {
    return {
      onRecognitionStart: data => {
        this.emitter.emit(import_types.RealtimeMessageMessageEnum.RecognitionStarted, data);
      },
      onRecognitionEnd: () => {
        this.emitter.emit(import_types.RealtimeMessageMessageEnum.EndOfTranscript, this);
      },
      onFullReceived: data => {
        this.emitter.emit(import_types.RealtimeMessageMessageEnum.AddTranscript, data);
      },
      onPartialReceived: data => {
        this.emitter.emit(import_types.RealtimeMessageMessageEnum.AddPartialTranscript, data);
      },
      onFullTranslationReceived: data => {
        this.emitter.emit(import_types.RealtimeMessageMessageEnum.AddTranslation, data);
      },
      onPartialTranslationReceived: data => {
        this.emitter.emit(import_types.RealtimeMessageMessageEnum.AddPartialTranslation, data);
      },
      onError: data => {
        this.emitter.emit(import_types.RealtimeMessageMessageEnum.Error, data);
      }
    };
  }
  /**
   * Adds a listener for the specified event.
   *
   * @param event - The event to listen for. Should be one of the RealtimeMessageMessageEnum values.
   * @param listener - The callback function that will be called when the event is emitted.
   */
  addListener(event, listener) {
    this.emitter.addListener(event, listener);
  }
  /**
   * Removes a listener for the specified event.
   *
   * @param event - The event to remove the listener from. Should be one of the RealtimeMessageMessageEnum values.
   * @param listener - The callback function that will be removed.
   */
  removeListener(event, listener) {
    this.emitter.removeListener(event, listener);
  }
  /**
   * Starts the realtime transcription session.
   *
   * @param transcriptionConfig - The config for the transcription. If not provided, the default options from the config will be used.
   * @param audioFormat - The audio format of the audio data that will be sent to the server. If not provided, the default audio format from the config will be used.
   * @returns Promise that resolves when the session is started.
   */
  async start(config) {
    var _config$transcription;
    const runtimeKey = typeof this.connectionConfig.apiKey === "string" ? this.connectionConfig.apiKey : await this.connectionConfig.apiKey();
    let error = null;
    await this.rtSocketHandler.connect(`${this.connectionConfig.realtimeUrl}/${(config === null || config === void 0 ? void 0 : (_config$transcription = config.transcription_config) === null || _config$transcription === void 0 ? void 0 : _config$transcription.language) || import_handlers.defaultLanguage}`, runtimeKey, this.connectionConfig.appId).catch(err => {
      error = new Error(`Unable to connect to RT runtime: ${JSON.stringify(err)}`);
    });
    if (error) {
      return Promise.reject(error);
    }
    return this.rtSocketHandler.startRecognition(config);
  }
  /**
   * Stops the realtime transcription session.
   *
   * @returns Promise that resolves when the session is stopped.
   */
  async stop() {
    return this.rtSocketHandler.stopRecognition().catch(err => {
      return new Error(`Unable to stop recognition cleanly ${JSON.stringify(err)}`);
    });
  }
  /**
   * Sends audio data to the server.
   *
   * @param data - The audio data to send to the server. Should be a Float32Array. PCM audio.
   */
  sendAudio(data) {
    this.rtSocketHandler.sendAudioBuffer(data);
  }
  /**
   * Checks if the session is connected to the server.
   *
   * @returns True if the session is connected to the server, false otherwise.
   */
  isConnected() {
    return this.rtSocketHandler.isConnected();
  }
}